import { FilterPanel, Header, MarginPosition, StyledFlex } from '@dreryk/react-components';

import { translationKeys } from './translations';
import { GroupSessionsTable } from './table/GroupSessionsTable';
import { GroupsSessionsCreateAction } from './table/actions/GroupsSessionsCreateAction';
import { GroupSessionsPanelActionBar } from './GroupSessionsPanelActionBar';
import { GroupSessionsFilterPanel } from './filters/GroupSessionsFilterPanel';
import { GroupSessionsFilterPanelFormBean } from './filters/GroupSessionsFilterPanel.types';
import { GROUP_SESSIONS_FILTER_PANEL_DEFAULT_VALUES } from './GroupSessionsPanel.constants';

export const GroupSessionsPanel = (): JSX.Element => (
   <FilterPanel.Provider<GroupSessionsFilterPanelFormBean>
      storageKeyPrefix={'egabinet-desktop'}
      defaultValues={GROUP_SESSIONS_FILTER_PANEL_DEFAULT_VALUES}
   >
      <GroupSessionsPanelActionBar>
         <StyledFlex gap={'18px'} direction={'column'} flex={'1'}>
            <StyledFlex gap={'12px'} justifyContent={'space-between'} alignItems={'center'}>
               <Header testId={'groupSessionsHeader'} margin={MarginPosition.BOTTOM}>
                  {translationKeys.groupSessions}
               </Header>
               <FilterPanel.VisibilitySwitch />
            </StyledFlex>
            <GroupSessionsFilterPanel />
            <GroupSessionsTable />
            <GroupsSessionsCreateAction />
         </StyledFlex>
      </GroupSessionsPanelActionBar>
   </FilterPanel.Provider>
);
